/**
 * Map saved sets API client
 */
import { apiClient } from "../client";
import type {
  MapSavedSetListItem,
  MapSavedSetDetails,
  CreateSavedSetRequest,
  CreateSavedSetResponse,
  UpdateSavedSetRequest,
  TogglePostalCodeResponse,
  ToggleElectoralDistrictResponse
} from "./types";

const BASE = "map-saved-sets";

export async function fetchSavedSetsList(): Promise<MapSavedSetListItem[]> {
  const { data } = await apiClient.get<MapSavedSetListItem[]>(BASE);
  return data;
}

export async function fetchSavedSetDetails(
  id: string
): Promise<MapSavedSetDetails> {
  const { data } = await apiClient.get<MapSavedSetDetails>(
    `${BASE}/${id}/details`
  );
  return data;
}

export async function createSavedSet(
  request: CreateSavedSetRequest
): Promise<CreateSavedSetResponse> {
  const { data } = await apiClient.post<CreateSavedSetResponse>(BASE, {
    name: request.name,
    municipalityPolygonId: request.municipalityPolygonId
  });
  return data;
}

export async function updateSavedSet(
  id: string,
  request: UpdateSavedSetRequest
): Promise<void> {
  await apiClient.put(`${BASE}/${id}`, {
    name: request.name,
    municipalityPolygonId: request.municipalityPolygonId
  });
}

export async function deleteSavedSet(id: string): Promise<void> {
  await apiClient.delete(`${BASE}/${id}`);
}

export async function togglePostalCode(
  savedSetId: string,
  postalCodeId: string
): Promise<TogglePostalCodeResponse> {
  const { data } = await apiClient.post<TogglePostalCodeResponse>(
    `${BASE}/${savedSetId}/postal-codes/${postalCodeId}/toggle`
  );
  return data;
}

export async function togglePriorityElectoralDistrict(
  savedSetId: string,
  districtId: string
): Promise<ToggleElectoralDistrictResponse> {
  const { data } = await apiClient.post<ToggleElectoralDistrictResponse>(
    `${BASE}/${savedSetId}/priority-electoral-districts/${districtId}/toggle`
  );
  return data;
}
